import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	label: {
		id: 'search-page.results.product-results.third-party.conversation-search-result.label',
		defaultMessage: 'Channel',
		description: "Use to label a conversation search result's type",
	},
	memberCount: {
		id: 'search-page.results.product-results.third-party.conversation-search-result.member-count',
		defaultMessage: '{count, plural, one {# member} other {# members}}',
		description: 'Use to describe the number of members in a conversation',
	},
	lastActive: {
		id: 'search-page.results.product-results.third-party.conversation-search-result.time-since-label',
		defaultMessage: 'Last active {formattedDate}',
		description: 'Use to describe the time since a conversation was last modified',
	},
	unknownChannel: {
		id: 'search-page.results.product-results.third-party.conversation-search-result.unknown-channel',
		defaultMessage: 'unknown-channel',
		description: 'Use to describe a channel when the name is not available',
	},
	privateChannel: {
		id: 'search-page.results.product-results.third-party.conversation-search-result.private-channel',
		defaultMessage: 'Private channel',
		description: 'Use to describe a private channel',
	},
});
